import React from 'react';
import { Modal, Backdrop, Paper, Table, TableHead, TableRow, TableCell, TableBody, Box, Typography } from '@mui/material';
import { formatValue } from '../../utils/utils';

const CategoryModal = ({ expandedCategory, handleCloseModal, calculateTotalForYear, currency }) => {
  const sortedYears = Object.keys(expandedCategory.monthlyBreakdown).sort((a, b) => parseInt(b) - parseInt(a));

  return (
    <Modal
      open={!!expandedCategory}
      onClose={handleCloseModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        style: { zIndex: 1201, backgroundColor: 'rgba(0, 0, 0, 0.5)' }
      }}
      sx={{ zIndex: 1300 }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Paper sx={{ overflow: 'auto', padding: 4, maxWidth: '90%', maxHeight: '90%', zIndex: 1300 }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            {expandedCategory.category} - Detalhamento por Ano
          </Typography>
          <Table aria-label="expanded-table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Ano</TableCell>
                <TableCell align="center">Jan</TableCell>
                <TableCell align="center">Fev</TableCell>
                <TableCell align="center">Mar</TableCell>
                <TableCell align="center">Abr</TableCell>
                <TableCell align="center">Mai</TableCell>
                <TableCell align="center">Jun</TableCell>
                <TableCell align="center">Jul</TableCell>
                <TableCell align="center">Ago</TableCell>
                <TableCell align="center">Set</TableCell>
                <TableCell align="center">Out</TableCell>
                <TableCell align="center">Nov</TableCell>
                <TableCell align="center">Dez</TableCell>
                <TableCell align="center">
                  <Typography component="span" fontWeight="bold">
                    Total
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedYears.map((year) => {
                const monthlyValues = expandedCategory.monthlyBreakdown[year] || [];
                const total = calculateTotalForYear(monthlyValues);

                return (
                  <TableRow key={`${expandedCategory.category}-${year}`}>
                    <TableCell align="center">{year}</TableCell>
                    {monthlyValues.map((value, index) => (
                      <TableCell key={`${expandedCategory.category}-${year}-${index}`} align="center">
                        {formatValue(value, currency)}
                      </TableCell>
                    ))}
                    <TableCell align="center">
                      <Typography component="span" fontWeight="bold">
                        {formatValue(total, currency)}
                      </Typography>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>
      </Box>
    </Modal>
  );
};

export default CategoryModal;
